// extracted by mini-css-extract-plugin
module.exports =  {"option":"option-vFOAS","heading":"heading-dYMDt","content":"content-P2T0i","icon":"icon-fE4hv","label":"label-qI6Vh"};